"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _DropdownContext = require("../../form/select/dropdown/DropdownContext");

var _layout = require("../../layout");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var _excluded = ["getItemProps", "renderItem", "isHighlighted", "item", "index", "itemAsString", "selectedItemsAsString", "isSelected", "isNavigation", "isGroupItem"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropdownLi = function DropdownLi(_ref) {
  var getItemProps = _ref.getItemProps,
      renderItem = _ref.renderItem,
      isHighlighted = _ref.isHighlighted,
      item = _ref.item,
      index = _ref.index,
      itemAsString = _ref.itemAsString,
      selectedItemsAsString = _ref.selectedItemsAsString,
      isSelected = _ref.isSelected,
      isNavigation = _ref.isNavigation,
      isGroupItem = _ref.isGroupItem,
      htmlProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_DropdownContext.DropdownContext),
      isSearchable = _useContext.isSearchable,
      withCustomSelectionOptions = _useContext.withCustomSelectionOptions;

  var renderDefaultGroupItem = function renderDefaultGroupItem() {
    return (0, _core.jsx)(_layout.Row, {
      alignItems: "center"
    }, (0, _core.jsx)(_layout.View, {
      padding: {
        left: _constants.GROUP_ITEM_PADDING
      }
    }, item));
  };

  var renderedItem;

  if (!!renderItem) {
    renderedItem = renderItem(item, {
      isHovered: isHighlighted
    });
  } else if (isGroupItem) {
    renderedItem = renderDefaultGroupItem();
  } else {
    renderedItem = item;
  } // Override default Downshift behavior which is aria-selected on hover
  // Use aria-selected to mark selected items in multi-select
  // Don't use aria-selected at all in single select because of inconsistent behavior in Screen Readers


  var selectedItemProps = selectedItemsAsString ? {
    'aria-selected': selectedItemsAsString.includes(itemAsString)
  } : {
    'aria-selected': undefined
  };
  return (0, _core.jsx)(_helperComponents.StyledDropdownLi, (0, _extends2.default)({
    isHighlighted: isHighlighted,
    isSearchable: isSearchable,
    isSelectedNavigation: isSelected && isNavigation,
    withCustomSelectionOptions: withCustomSelectionOptions,
    isGroupItem: isGroupItem
  }, !!getItemProps ? getItemProps({
    item: item,
    index: index
  }) : {}, selectedItemProps, htmlProps), renderedItem);
};

DropdownLi.displayName = 'DropdownLi';

var _default = /*#__PURE__*/(0, _react.memo)(DropdownLi);

exports.default = _default;